import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2ce50e5a&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce50e5a')) {
      api.createRecord('2ce50e5a', component.options)
    } else {
      api.reload('2ce50e5a', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=2ce50e5a&", function () {
      api.rerender('2ce50e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/NotFound.vue"
export default component.exports